import Modal from "../../components/UI/modal/Modal";
import SearchModal from "../UI/modal/SearchModal";

const Main = () => {
  return (
    <>
      <Modal />
      <SearchModal />
    </>
  );
};

export default Main;
